module.exports = __webpack_public_path__ + "static/11-66f17ea9f455dc91c01cda87b4053028.png";